import moment from 'moment';
import _isEmpty from 'lodash/isEmpty';
import { enableCancellationRules } from 'helper/configuration';
import { PAX_HISTORY_FETCH_LIMIT } from 'constants/history-constants';
import { createActionType, createFetchAction } from './action-helper';
import endpoints from './history-endpoints';

export const FETCH_HISTORY = createActionType('FETCH_HISTORY');
export const CLEAR_HISTORY = createActionType('CLEAR_HISTORY');
export const CANCEL_DELIVERY = createActionType('CANCEL_DELIVERY');
export const FETCH_CANCEL_REASONS = createActionType('FETCH_CANCEL_REASONS');
export const FILTER_CANCEL_DELIVERY = createActionType(
  'FILTER_CANCEL_DELIVERY',
);
export const DOWNLOAD_HISTORY = createActionType('DOWNLOAD_HISTORY');
export const CLEAR_FETCHING_STATUS = 'CLEAR_FETCHING_STATUS';
export const CLEAR_CANCEL_STATUS = 'CLEAR_CANCEL_STATUS';
export const SUBMIT_CANCEL_REASONS_SINGLE_ORDER =
  'SUBMIT_CANCEL_REASONS_SINGLE_ORDER';
export const DECREMENT_TOTAL_COUNT = 'DECREMENT_TOTAL_COUNT';
export const GET_TOTAL_COUNT = createActionType('GET_TOTAL_COUNT');
export const clearHistoryAction = () => ({
  type: CLEAR_HISTORY,
});

export const clearFetchingStatusAction = () => ({
  type: CLEAR_FETCHING_STATUS,
});
export const fetchHistoryAction = (params, callback) =>
  createFetchAction(
    FETCH_HISTORY,
    endpoints.getHistoryEpt(params),
    {
      method: 'GET',
    },
    callback,
  );

export const FETCH_HISTORY_CONSECUTIVELY_V1 = 'FETCH_HISTORY_CONSECUTIVELY_V1';

export const fetchHistoryConsecutivelyV1 = (params, callback) => ({
  type: FETCH_HISTORY_CONSECUTIVELY_V1,
  payload: { params, callback },
});

export const onCancelDeliveryAction = (deliveryID, isMSDBooking, callback) =>
  createFetchAction(
    CANCEL_DELIVERY,
    endpoints.getCancelDeliveryEpt(deliveryID),
    {
      method: 'DELETE',
      body: {
        deliveryID,
        isMSDBooking,
      },
    },
    callback,
  );

export const downloadHistoryAction = (params, callback) =>
  createFetchAction(
    DOWNLOAD_HISTORY,
    endpoints.getHistoryEpt(params),
    { method: 'GET' },
    callback,
  );
export const onFilterCancelDeliveryAction = deliveryID => dispatch =>
  dispatch({
    type: FILTER_CANCEL_DELIVERY.SUCCESS,
    data: deliveryID,
  });
export const clearCancelFailedAction = () => dispatch =>
  dispatch({ type: CLEAR_CANCEL_STATUS });

export const fetchCancelReasonsAction = () =>
  createFetchAction(FETCH_CANCEL_REASONS, endpoints.getCancelReasonsEpt(), {
    method: 'GET',
  });

export const submitCancelReasonsAction = cancelReq => ({
  type: SUBMIT_CANCEL_REASONS_SINGLE_ORDER,
  cancelReq,
});

export const getTotalCountAction = (companyID, callback) =>
  createFetchAction(
    GET_TOTAL_COUNT,
    endpoints.getHistoryEpt({
      fromDate: moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      orderState: 'ACTIVE_DELIVERY',
      start: 0,
      limit: 1,
      companyID,
    }),
    {
      method: 'GET',
    },
    callback,
  );

export const decrementTotalCountAction = () => ({
  type: DECREMENT_TOTAL_COUNT,
});

// ----------------------V2------------------------

export const UPDATE_ONGOING_ORDER_STATE_CHANGES =
  'UPDATE_ONGOING_ORDER_STATE_CHANGES';
export const UPDATE_ONGOING_ORDER_COUNTING = 'UPDATE_ONGOING_ORDER_COUNTING';
export const FETCH_HISTORY_V2 = createActionType('FETCH_HISTORY_V2');
export const FETCH_ONGOING_DELIVERIES_INTERVAL =
  'FETCH_ONGOING_DELIVERIES_INTERVAL';
export const PAX_FETCH_ONGOING_DELIVERIES_INTERVAL =
  'PAX_FETCH_ONGOING_DELIVERIES_INTERVAL';
export const STOP_FETCH_ONGOING_DELIVERIES_INTERVAL =
  'STOP_FETCH_ONGOING_DELIVERIES_INTERVAL';
export const STOP_PAX_FETCH_ONGOING_DELIVERIES_INTERVAL =
  'STOP_PAX_FETCH_ONGOING_DELIVERIES_INTERVAL';
export const FETCH_ONGOING_DELIVERIES = createActionType(
  'FETCH_ONGOING_DELIVERIES',
);
export const PAX_FETCH_ONGOING_DELIVERIES = createActionType(
  'PAX_FETCH_ONGOING_DELIVERIES',
);
export const FETCH_COMPLETED_DELIVERIES = createActionType(
  'FETCH_COMPLETED_DELIVERIES',
);

export const fetchOngoingDeliveriesIntervalAction = ({
  companyID,
  keywords,
}) => ({
  type: FETCH_ONGOING_DELIVERIES_INTERVAL,
  payload: { companyID, keywords },
});

export const paxFetchOngoingDeliveriesIntervalAction = () => ({
  type: PAX_FETCH_ONGOING_DELIVERIES_INTERVAL,
});

export const stopFetchOngoingDeliveriesIntervalAction = () => ({
  type: STOP_FETCH_ONGOING_DELIVERIES_INTERVAL,
});

export const stopPaxFetchOngoingDeliveriesIntervalAction = () => ({
  type: STOP_PAX_FETCH_ONGOING_DELIVERIES_INTERVAL,
});

export const fetchOngoingDeliveriesAction = ({ companyID, keywords }) =>
  createFetchAction(
    FETCH_ONGOING_DELIVERIES,
    endpoints.getOngoingDeliveriesEpt({ companyID, keywords }),
    {
      method: 'GET',
    },
  );
export const paxFetchOngoingDeliveriesAction = () =>
  createFetchAction(
    PAX_FETCH_ONGOING_DELIVERIES,
    endpoints.getPaxOngoingDeliveriesEpt(),
    {
      method: 'GET',
    },
  );

export const paxFetchCompletedDeliveriesAction = ({
  startTimestamp = 0,
  endTimestamp,
  limit = PAX_HISTORY_FETCH_LIMIT,
  queryString = null,
}) => {
  const searchQuery =
    queryString ||
    new URLSearchParams({
      'input.startDate': startTimestamp,
      'input.endDate': endTimestamp,
      'input.limit': limit,
    }).toString();

  return createFetchAction(
    FETCH_COMPLETED_DELIVERIES,
    endpoints.getPaxHistoryDeliveriesEpt(searchQuery),
    {
      method: 'GET',
    },
  );
};

export const fetchCompletedDeliveriesAction = ({
  companyID,
  fromDate,
  toDate,
  keywords,
  states,
  limit,
  queryString = null,
  orderType,
}) => {
  // refetch completed bookings in history-epics.js
  if (!_isEmpty(queryString)) {
    return createFetchAction(
      FETCH_COMPLETED_DELIVERIES,
      endpoints.getHistoryDeliveriesEpt(queryString),
      {
        method: 'GET',
      },
    );
  }

  const params = {
    'params.offset': 0,
    'params.limit': limit,
    'params.fromDate': fromDate,
    'params.toDate': toDate,
    'params.companyID': companyID,
    'params.orderType': orderType,
  };

  const urlSearchParams = new URLSearchParams(params);
  states.forEach(s => {
    urlSearchParams.append('params.states', s);
  });

  if (keywords && !_isEmpty(keywords)) {
    urlSearchParams.append('params.keywords', keywords);
  }
  return createFetchAction(
    FETCH_COMPLETED_DELIVERIES,
    endpoints.getHistoryDeliveriesEpt(urlSearchParams.toString()),
    {
      method: 'GET',
    },
  );
};

// 2021/03/10 - Not being used until BE implements pagination correctly
export const FETCH_ALL_PREVIOUS_BOOKINGS = 'FETCH_ALL_PREVIOUS_BOOKINGS';
export const fetchAllPreviousBookingsAction = params => ({
  type: FETCH_ALL_PREVIOUS_BOOKINGS,
  params,
});

// 2021/03/10 - Not being used until BE implements pagination correctly
export const FETCH_ALL_PREVIOUS_BOOKINGS_SUCCESS =
  'FETCH_ALL_PREVIOUS_BOOKINGS_SUCCESS';
export const fetchAllPreviousBookingsSuccessAction = payload => ({
  type: FETCH_ALL_PREVIOUS_BOOKINGS_SUCCESS,
  payload,
});

export const CANCEL_DELIVERY_V2 = createActionType('CANCEL_DELIVERY_V2');
export const cancelDeliveryActionV2 = ({
  deliveryID,
  isMSDBooking,
  callback,
}) =>
  createFetchAction(
    CANCEL_DELIVERY_V2,
    endpoints.getCancelDeliveryEpt(deliveryID),
    {
      method: 'DELETE',
      body: {
        deliveryID,
        isMSDBooking,
        enableCancellationRules: enableCancellationRules(),
      },
    },
    callback,
  );

export const SUBMIT_CANCEL_REASONS_FOR_MULTIPLE_ORDERS =
  'SUBMIT_CANCEL_REASONS_FOR_MULTIPLE_ORDERS';

export const submitCancelReasonsForMultipleOrdersAction = multipleCancelReq => ({
  type: SUBMIT_CANCEL_REASONS_FOR_MULTIPLE_ORDERS,
  multipleCancelReq,
});

export const PAX_CANCEL_DELIVERY = createActionType('PAX_CANCEL_DELIVERY');
export const paxCancelDeliveryAction = ({
  deliveryID,
  expressServiceID,
  callback,
}) =>
  createFetchAction(
    PAX_CANCEL_DELIVERY,
    endpoints.getPaxCancelDeliveryEpt({
      deliveryID,
      expressServiceID,
    }),
    { method: 'DELETE' },
    callback,
  );
